import { render, staticRenderFns } from "./InventoryView.vue?vue&type=template&id=1aac166a&"
import script from "./InventoryView.vue?vue&type=script&lang=js&"
export * from "./InventoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports